import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import ReactBSAlert from 'react-bootstrap-sweetalert'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import Grid from '@material-ui/core/Grid'
import Loader from 'components/general/Loader'
import AdminAPI from 'config/api/AdminAPI'
import { onError } from 'config/lib/errorLib'
import filterFactory, { textFilter, selectFilter, numberFilter } from 'react-bootstrap-table2-filter'
import ReturnRequestModal from 'components/admin/ReturnRequestModal'
import { getProductString } from 'config/helpers/Helpers'
import { NotificationManager } from 'react-notifications'
import CardContent from '@material-ui/core/CardContent'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import componentStylesButtons from 'assets/theme/components/button.js'
import moment from 'moment-timezone'

const useStyles = makeStyles(componentStyles)
const useStylesButtons = makeStyles(componentStylesButtons)

function ReturnRequestsTable(props) {
    const bstable: any = React.useRef()
    const classes = { ...useStyles(), ...useStylesButtons() }
    const api = new AdminAPI()

    const requests = props.requests
    const processing = props.processing
    // brokers.sort((a, b) => {
    //     return b.remainingLeads - a.remainingLeads
    // })
    const [request, setRequest] = useState(null)
    const [showRequestModal, setShowRequestModal] = useState(false)
    const [selected, setSelected] = useState([])
    const [loading, setLoading] = useState(false)
    const [alert, setAlert] = useState(false)

    function selectRequest(request) {
        let newSelected = [...selected]
        newSelected.push(request)
        setSelected(newSelected)
    }

    function deselectRequest(request) {
        let newSelected = [...selected]
        let index = selected.findIndex(item => item.phone === request.phone)
        newSelected.splice(index, 1)
        setSelected(newSelected)
    }

    function acceptRequestMultiple() {
        if (processing) return
        bstable.current.selectionContext.selected = []
        //console.log(bstable)
        props.acceptRequestMultiple(selected)
        setSelected([])
        setAlert(null)
    }

    function rejectRequestMultiple() {
        if (processing) return
        bstable.current.selectionContext.selected = []
        //console.log(bstable)
        props.rejectRequestMultiple(selected)
        setSelected([])
        setAlert(null)
    }

    function showBulkAcceptWarning() {
        let containsPension = false

        for (let request of selected) {
            if (request.product === 'pensions') {
                containsPension = true
            }
        }

        if (containsPension) {
            NotificationManager.error('Can not bulk accept pension lead returns. Please review these individually.')
        }
        else {
            setAlert(
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-100px' }}
                    title='Are you sure?'
                    onConfirm={() => acceptRequestMultiple()}
                    onCancel={() => setAlert(false)}
                    cancelBtnCssClass='btn-secondary'
                    confirmBtnBsStyle='success'
                    cancelBtnText='Cancel'
                    confirmBtnText='Yes, Accept Requests'
                    showCancel
                    btnSize=''
                >
                    This will accept {selected.length} return requests immediately
                </ReactBSAlert>
            )
        }
    }

    function showBulkRejectWarning() {
        setAlert(
            <ReactBSAlert
                warning
                style={{ display: 'block', marginTop: '-100px' }}
                title='Are you sure?'
                onConfirm={() => rejectRequestMultiple()}
                onCancel={() => setAlert(false)}
                cancelBtnCssClass='btn-secondary'
                confirmBtnBsStyle='danger'
                cancelBtnText='Cancel'
                confirmBtnText='Yes, Reject Requests'
                showCancel
                btnSize=''
            >
                This will reject {selected.length} return requests immediately
            </ReactBSAlert>
        )
    }

    const selectRow = {
        mode: 'checkbox',
        //clickToSelect: true,
        //selected: [this.state.jobOrderValue],
        //clickToExpand: true,
        selectColumnStyle: { textAlign: 'center', margin: 'auto', width: '50px' },
        onSelect: (row, isSelect, selected, e) => {
            //this.handleOnSelect(row, isSelect, selected, e);
            // console.log('selected')
            // console.log(row)
            // console.log(isSelect)
            // console.log(selected)
            if (isSelect) {
                selectRequest(row)
            }
            else {
                deselectRequest(row)
            }
        },
        onSelectAll: (isSelect, rows, e) => {
            if (isSelect) {
                setSelected(rows)
            }
            else {
                setSelected([])
            }
        }
    }

    const columns = [
        {
            dataField: 'companyName',
            text: 'Client Name',
            //sort: true,
            //filter: textFilter(),
            formatter: (cell, row) => {
                return (<Box className='hover-text primary-text' onClick={() => openRequestModal(row)}>{row.companyName} ({row.companyId.toUpperCase()})</Box>)
                
            }
        },
        {
            dataField: 'brokerName',
            text: 'Broker',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.brokerName ? row.brokerName : '-'}</>
            }
        },
        {
            dataField: 'product',
            text: 'Product',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{getProductString(row.product)}</>
            }
        },
        {
            dataField: 'leadName',
            text: 'Lead Name',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.leadName}</>
            }
        },
        {
            dataField: 'leadEmail',
            text: 'Lead Email',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.email}</>
            }
        },
        {
            dataField: 'createdAt',
            text: 'Requested',
            sort: true,
            formatter: (cell, row) => {
                return <>{moment(row.createdAt).format('DD/MM HH:mm')}</>
                //return <>{moment().diff(row.createdAt, 'days')} days ago</>
                //return <>{moment(row.createdAt).fromNow()}</>
            }
        }
        // {
        //     dataField: 'actions',
        //     text: 'Actions',
        //     //sort: true,
        //     //filter: textFilter(),
        //     formatter: (cell, row) => {
        //         return (
        //             <Button
        //                 variant='contained'
        //                 color='primary'
        //                 size='small'
        //                 onClick={() => alert('Charge now')}
        //             >
        //                 Charge Now
        //             </Button>
        //         )
        //     }
        // }
    ]

    function openRequestModal(request) {
        setRequest(request)
        setShowRequestModal(true)
    }

    function closeRequestModal() {
        setShowRequestModal(false)
        setRequest(null)
    }

    return (
        <Card>
            {alert}
            {!loading ? (
                <>
                    <CardHeader
                        subheader={
                            <>
                                <Box display='flex' style={{justifyContent: 'space-between'}}>
                                    <Box>
                                        <Box
                                            component={Typography}
                                            variant='h2'
                                            marginBottom='0!important'
                                        >
                                            <Box component='span'>Lead Return Requests ({props.requests.length})</Box>
                                        </Box>
                                        <Box
                                            component='p'
                                            fontSize='.875rem'
                                            marginBottom='0'
                                            marginTop='0'
                                            lineHeight='1.7'
                                            fontWeight='300'
                                        >
                                            All pending lead return requests
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        }
                        classes={{ root: classes.cardHeaderRoot }}
                    ></CardHeader>
                    
                    {processing &&
                        <Box display='flex' alignItems='center' style={{margin: '0 1.5rem 1rem', padding: '0.75rem 1rem', borderRadius: '0.375rem', background: '#fff3cd', color: '#856404'}}>
                            <Loader height={6} />
                            <Box marginLeft='1rem'>
                                {processing.action === 'accept' ? 'Accepting' : 'Rejecting'} {processing.count} return request{processing.count === 1 ? '' : 's'}… please wait, this can take a minute. Don't resubmit.
                            </Box>
                        </Box>
                    }
                    <div className='table-container'>
                        <BootstrapTable 
                            ref={bstable}
                            keyField='phone' 
                            data={ requests } 
                            columns={ columns } 
                            selectRow={ selectRow }
                            filter={ filterFactory() } 
                            noDataIndication={<Box>No pending requests</Box>}
                            className='custom-table'
                        />
                    </div>

                    <Grid container>
                        {selected.length > 0 && props.requestStatus === 'pending' && 
                            <>
                                <Grid item xs={12} style={{margin: '0.5rem'}}>
                                    <Box >
                                        <Button
                                            //component={Box}
                                            onClick={() => showBulkAcceptWarning()}
                                            disabled={!!processing}
                                            color='primary'
                                            variant='contained'
                                            size='medium'
                                            style={{margin: '0.5rem'}}
                                        >
                                            Accept {selected.length} Return Requests
                                        </Button>
                                        <Button
                                            //component={Box}
                                            onClick={() => showBulkRejectWarning()}
                                            disabled={!!processing}
                                            variant='contained'
                                            size='medium'
                                            style={{margin: '0.5rem'}}
                                            classes={{
                                                root: classes.buttonContainedError,
                                            }}
                                        >
                                            Reject {selected.length} Return Requests
                                        </Button>
                                    </Box>
                                </Grid>
                            </>
                        }
                    </Grid>
                    <CardContent>
                    <Grid container style={{marginTop: '2rem'}}>
                        <Grid item xs={12}>
                            <h3>Active Return Rules</h3>
                        </Grid>
                        <Grid item xs={12}>
                            <Box style={{color: '#525f7f'}}>
                                <ul>
                                    <li>Default return period is 1 week</li>
                                    <li>If product is pensions return period is 12 weeks</li>
                                    <li>If company is CIB return period is 12 weeks</li>
                                    <li>If company is MF return period is 2 weeks</li>
                                    <li>No % return caps are active</li>
                                </ul>
                            </Box>
                        </Grid>
                    </Grid>
                    </CardContent>

                    {showRequestModal &&
                        <ReturnRequestModal 
                            isOpen={showRequestModal}
                            close={() => closeRequestModal()}
                            request={request}
                            updateRequest={(request) => props.updateRequest(request)}
                            deleteRequest={(request) => props.deleteRequest(request)}
                            showSuccessAlert={(text) => props.showSuccessAlert(text)}
                        />
                    }
                </>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Card>
    );
}

export default ReturnRequestsTable